import { render } from "./NewInvoicePage.vue?vue&type=template&id=589bf35c"
import script from "./NewInvoicePage.vue?vue&type=script&lang=js"
export * from "./NewInvoicePage.vue?vue&type=script&lang=js"

import "./NewInvoicePage.vue?vue&type=style&index=0&id=589bf35c&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__